// Update. 8/11 2020
/**************************************************/
/**** Data Grid : OPTIONS Default value        ****/
/**************************************************/
const DEFAULT_OPTIONS = {
    //====  Style  ==========================//
    /** 
     * [HEIGHT] Height : 테이블 높이
     * Info/Pager 영역을 제외한 테이블의 높이를 지정합니다.
     * Header 영역과 Contents 영역을 포함합니다.
     * 값이 없는 경우 데이터 높이만큼 보여줍니다. (간단한 테이블에서 사용합니다.)
     * Default : null
     */
    height : null,
    /**
     * [HEIGHT] rowHeight : 행의 높이
     * 컨텐츠 영역에 표시될 행의 높이를 지정합니다.
     * DATA-GRID는 고정된 행의 높이를 갖습니다.
     * 값은 px 단위로 입력합니다.
     * Default : 48(px)
     */
    rowHeight: 48,
    /**
     * [HEIGHT] headerHeight : 헤더 한 행의 높이
     * 헤더 영역의 한 행의 높이를 지정합니다.
     * 값은 px 단위로 입력합니다.
     * Deafult : 40(px)
     */
    headerHeight: 40,
    /**
     * [HEIGHT] summaryHeight : 요약 행의 높이
     * 그리드 하단에 요약 행의 높이를 지정합니다.
     * "summary" slot을 지정하면 해당 옵션의 값으로 행의 높이가 지정됩니다.
     * 값은 px 단위로 입력합니다.
     * Deafult : 64(px)
     */
    summaryHeight: 64,
    /**
     * [HEIGHT] groupSummaryHeight : 그룹요약 행의 높이
     * 그룹별 요약 행의 높이를 지정합니다..
     * 값은 px 단위로 입력합니다.
     * Deafult : 32(px) 
     */
    groupSummaryHeight: 32,
    /**
     * [HEIGHT] groupRowHeight : 묶음행 높이
     * 여러 행을 묶는 그룹핑 기능을 활성화 하였을때 묶음 행의 높이를 지정합니다..
     * 값은 px 단위로 입력합니다.
     * Deafult : 28(px)
     */
    groupRowHeight: 28,
    /**
     * [WIDTH] defaultFieldWidth : 기본 컬럼 너비
     * 아무런 값이 설정되지 않았을 경우 최소 컬럼의 너비입니다.
     * 값이 설정되지 않는경우 그리드의 남은 여백만큼 공간을 차지하게 되는데(stretch기능)
     * 지정된 default field width 이하로는 줄어들지 않습니다.
     * 값은 px 단위로 입력합니다.
     * Deafult : 100(px)
     */
    defaultFieldWidth : 100,
    /**
     * [INFO] noInfo : 정보영역 표시여부
     * 그리드의 정보 영역으로 표시할지 여부를 지정합니다.
     * Default : false
     */
    noInfo : false,
    /**
     * [INFO] rightInfo : 기본정보의 표현위치
     * Total과 perPage에 대한 정보를 보여줄 위치를 지정합니다.
     * 기본값은 좌측정렬이며, 해당 props를 정의 할 경우 테이블 우측 상단에 정보가 표기되게 됩니다.
     * Default : false
     */
    rightInfo : false,
    /**
     * [INFO] baseInfo : 기본 정보의 사용 여부
     * Total과 perPage에 대한 정보를 보여줄 지 여부를 판단한다.
     * 값이 활성화 된 경우 left-info을 지정하면 기본 정보 영역을 덮어쓰며
     * 값이 비활성화 된 경우 left-info 영역은 기본 정보 영역에 덧 붙여 추가됩니다.
     * Default : true
     */
    noBaseInfo : true,
    /**
     * [FORMAT] cellStyleBordered : 스타일-외곽선 형
     * 테이블의 형태를 외곽선 형으로 만들어줍니다.
     */
    styleBordered : false,
    //====  Value & Format  ==================//
    /**
     * [FORMAT] dateFormat : 기본 날짜 포멧
     * 기본으로 제공하는 날짜 포멧입니다.
     * date 유형의 필드는 자동으로 아래 포멧이 적용됩니다.
     * Deafult : 'YYYY-MM-DD'
     */
    dateFormat : 'YYYY-MM-DD',
    /**
     * [FORMAT] dateEditFormat : 날짜 수정 포멧
     * 날짜 형태의 데이터를 수정할 때에 사용될 포멧입니다.
     * 날짜를 수정 포멧은 YYYY/MM/DD 3가지 키워드만 가능합니다.
     * Deafult : 'YYYY-MM-DD'
     */
    dateEditFormat : 'YYYY-MM-DD',
    /**
     * [FORMAT] timezone : 타임존
     * 화면에 보여질 날짜의 타임존을 설정합니다.
     * 값은 -12부터 +14까지의 실수를 입력합니다.
     * ex) 서울 +9, 런던 +0, 뉴욕 -5 등...
     * 인도, 이란과 같은 30분 단위의 Timezone의 경우 0.5단위로 입력합니다.
     * 값을 입력하지 않는 경우 현재 Client의 timezone을 따릅니다.
     * Deafult : null
     */
    timezone : null,
    /**
     * [FORMAT] numberFormat : 기본 숫자 포멧
     * 숫자 형태의 데이터를 수정할 때에 사용될 포멧입니다.
     * Deafult : '#,###.##'
     */
    numberFormat : '#,###.##',
    //====  Column  ==========================//
    /**
     * [COLUMN] resizableColumn : 컬럼 리사이즈 기능
     * 컬럼 리사이즈 기능을 허용할지 여부입니다.
     * Deafult : false
     */
    resizableColumn : false,
    /**
     * [COLUMN] configurableColumn : 컬럼 조정기능
     * 컬럼을 조정할수 있는 기능을 제공합니다.
     * 해당 옵션이 활성화 되면 헤더영역 우측에 설정 아이콘이 나타납니다.
     * 해당 아이콘을 눌러 컬럼 설정 팝업을 열어 헤더의 순서, 너비, 보이기/숨기기 여부를
     * 설정할 수 있습니다.
     * - 커스텀 헤더(multi-row포함)를 사용할때에는 해당 옵션은 무시됩니다.
     * Deafult : false
     */
    configurableColumn : false,
    /**
     * [COLUMN] blockFreeze : 틀고정 금지
     * 필드에서 틀 고정을 지정하였더라도 해당 옵션을 사용하여 틀고정을 막을 수 있습니다.
     * 대게는 그리드 내부에서 다른 옵션과 충돌이 날 경우 자동으로 활성화 시키는 데에 사용됩니다.
     * (역으로 활성화 상태(틀고정 금지)를 비 활성화(틀고정 허용) 상태로 변경하지는 않습니다.)
     * Deafult : false
     */
    blockFreeze : false,
    //====  Scroll  ==========================//
    /**
     * [SCROLL] infinityScroll : 인피니티 스크롤 기능
     * 인피니티 스크롤 기능을 켜고 끄는데 사용됩니다. (true/false)
     * Deafult : false
     */
    infinityScroll : false,
    /**
     * [SCROLL] scrollEventMargin : 스크롤 이벤트 여백
     * 스크롤 이벤트 중 끝(bottom)을 감지할 때에 적용할 여백을 지정합니다.
     * 값은 %로 지정가능합니다. 0~100 사이의 값을 지정해주세요.
     *    ex) 10 -> 하단 10%(위에서 부터 90%)지점 부터 event(grid:scroll-bottom) 발생 
     * Deafult : 0
     */
    scrollEventMargin : 0,
    //====  Sorting  ==========================//
    /**
     * [SORT] externalSort : 외부 정렬 여부
     * external sort 옵션이 활성화 되면 내부 정렬을 수행하지 않습니다.
     * Header를 클릭하면 정렬 필드 목록을 <b>grid:sorted</b> 이벤트를 통해 전달 받을 수 있습니다.
     * Deafult - false
     */
    externalSort : false,
    //====  FILTER  ==========================//
    /**
     * [FILTER] externalFilter : 외부 필터 여부
     * external filter 옵션이 활성화 되면 내부 필터링을 수행하지 않습니다.
     * 필터 정보를 입력하면 검색조건 정보를 <b>grid:filtered</b> 이벤트를 통해 전달 받을 수 있습니다.
     * Default : false
     */
    externalFilter : false,
    //====  Context  ==========================//
    /**
     * [CONTEXT] context : 컨텍스트 메뉴
     * 셀 영역을 우클릭을 했을때 나타나는 컨텍스트 메뉴를 지정합니다.
     * options 영역에 지정된 컨텍스트 메뉴는 field별 옵션과 동일하며
     * 어떤 필드를 눌렀을때 동일하게 나타납니다.
     * 해당 옵션에 값이 입력되는 경우 브라우저의 기본 기능을 대치합니다.
     * 값은 배열, 배열을 반환하는 함수, 또는 문자열 형태로 입력합니다.
     * Context Array(Array function) :
     *     각 배열은 객체 형태의 데이터를 사용하여 정의됩니다.
     *         [{text:'', action:'', icon:''},...]
     *         text   : Context 메뉴에 보일 제목을 입력합니다.
     *         action : 함수형태의 값을 입력합니다.
     *             클릭한 셀의 값과 행 정보를 매개변수로 받습니다.
     *             ex) action : function(val, row) {... do something}
     *         icon   : OPUS 표준 아이콘명을 입력합니다.
     *     만약 구분선을 추가하고 싶은 경우, 아래와 같은 객체를 입력합니다.
     *         {separator:true}
     * Context string :
     *     문자열로 입력한 경우 컨텍스트 메뉴를 선택하였을 때
     *     @grid:context:{keyword} 형태의 이벤트를 받을 수 있습니다.
     */
    context : null,
    /**
     * [CONTEXT] noContextIcon : 컨텍스트 메뉴 아이콘 허용여부
     * no-context icon 옵션이 활성화 되면, context메뉴에 입력한 Icon 속성이 무시됩니다.
     * Default :false
     */
    noContextIcon : false,
    //====  Selection  ==========================//
    /**
     * [SELECT] multiSelect : 단독/다중 선택 플래그
     * Row 단위로 선택할때에 동시에 여러개를 선택할 수 있게 해주는 플래그 입니다.
     * Deafult : false
     */
    multiSelect : false,
    /**
     * [SELECT] selectCheck : 선택 체크박스
     * Row 맨 앞에 선택되었는지 여부를 알 수 있는 checkbox를 보여줍니다..
     * Deafult : false
     */
    selectCheck : false,
    /**
     * [SELECT] selectCheck : 선택 체크박스
     * Row 맨 앞에 checkbox를 클릭했을때만 행을 선택할 수 있습니다.
     * 그 외 다른 영역에서는 일반적인 row click event만 제공합니다.
     * Deafult : false
     */
    selectCheckOnly : false,
    /**
     * [SELECT] selectCheckWidth : 선택 체크박스 너비
     * Row 맨 앞에 선택 체크박스의 너비입니다.
     * Deafult : 34(px)
     */
    selectCheckboxWidth : 34,
    /**
     * [SELECT] clickMode : 다중 선택시 Click Mode
     * 값은 [default | functional] 중 선택 가능합니다.
     *     default : 건단위 선택 건단위 해제
     *     functional : shift/ctrl click 모드 지원(ex. 윈도우 탐색기)
     *                  그냥 클릭시 단일 선택(기존 선택 해제)
     *      
     * Deafult : 'default'
     */
    clickMode : 'default',
    /**
     * [SELECT] cellMode : Cell mode
     * Cell 선택 모드 여부를 지정합니다.
     * Cell 선택 모드가 활성화 된 경우, 클릭 이벤트로는 Row를 선택할수 없으며
     * selectCheck 옵션을 활성화 한 경우에만 checkbox를 클릭하여 선택할수 있습니다.
     */
    cellMode : false,
    /**
     * [SELECT] checkIcon : Check icon
     * 체크 셀에서 선택되었을때 보여줄 아이콘 입니다..
     * default : checked
     */
    checkedIcon : 'checked',
    /**
     * [SELECT] cellMode : Cell mode
     * 체크 셀에서 선택 해제되었을때 보여줄 아이콘 입니다..
     * default : box
     */
    uncheckIcon : 'box',
    //====  Accordion  ==========================//
    /**
     * [ACCORDION] accordion : 아코디언 여부
     * 각 행 별로 자세한 정보를 표시할 수 있는 아코디언 기능을 활성화 합니다.
     * Deafult : false
     */
    accordion : false,
    /**
     * [ACCORDION] accordionColumnWidth : 아코디언 컬럼 너비
     * 아코디언 기능이 활성화 되었을때, 자동으로 생성되는 펼침 기호 컬럼의 너비입니다.
     * Deafult : 34
     */
    accordionColumnWidth : 34,
    
    /**
     * [ACCORDION] accordionVertical : 세로 아코디언
     * 아코디언 기능은 틀고정 옵션이 활성화 된 경우 기본적으로 세로로 나타나게 됩니다.
     * 해당 옵션은 틀고정이 활성화 되지 않았더라도 세로형태 동작하도록 활성화 합니다.
     * 값은 너비를 지정하며 0보다 큰 숫자가 입력된 경우 활성화 됩니다.
     */
    accordionVertical: null,
    // todo accordion - accordionExpandMulti : true/false
    //====  Grouping  ==========================//
    /**
     * [GROUPING] grouping : 행 그룹화
     * 특정 필드를 중심으로 행을 그룹화 시킬 수 있습니다.
     * 해당 속성이 활성화 된 경우 그룹화 필드를 대상으로 정렬이 강제됩니다.
     * 정렬의 순서(Ascending/Descending)를 바꿀수는 있지만
     * - 필드 정렬의 우선순위를 변경 하거나 정렬을 해제할 수는 없습니다.
     * - 해당 옵션을 활성화 한 경우, 다중선택의 클릭모드(clickMode)는 "default"로 고정됩니다.
     * 필드 명 배열형태로 입력합니다.
     *     ex) 'grouping' : ['code1', 'num2']
     * Deafult : []
     */
    grouping : [],
    /**
     * [GROUPING] groupHeader : 그룹 헤더
     * 그룹화 된 행들을 한꺼번에 제어할 수 있는 헤더 형태의 UX를 제공합니다.
     * grouping 옵션이 지정되어야 합니다.
     * - 해당 옵션을 활성화 한 경우 틀고정 속성은 무시됩니다.
     * default : false
     */
    groupHeader : false,
    /**
     * [GROUPING] groupSummary : 그룹 소계
     * 그룹화가 활성화 되었을때 각 그룹별로 소계 행을 추가합니다.
     * grouping 옵션이 지정되어야 합니다.
     * 옵션을 활성화 한 뒤, 필드 정의에서 "summary" 속성을 지정하거나, 
     * 사용자 정의 summary slot(group-summary)을 사용합니다.
     * default : false
     */
    groupSummary : false,
    /**
     * [GROUPING] groupMerge : 그룹 셀 병합
     * 그룹화가 활성화 되었을때 해당 필드를 대상으로 값이 같은 셀 끼리 합쳐줍니다.
     * grouping 옵션이 지정되어야 합니다.
     * - 해당 옵션을 활성화 한 경우 아코디언(accordion) 기능은 세로형태로 고정됩니다.
     * - 해당 옵션을 활성화 한 경우 행 수정 기능(rowEdit)은 무시됩니다.
     * - 해당 옵션은 그룹화 대상이 2개 이상인 경우 그룹 헤더(groupHeader)와 동시에 사용하였을 때의 동작을 보장하지 않습니다.
     *   시스템적으로 막혀있지는 않으나, 사용하지 않는것을 권고합니다.
     * default : false
     */
    groupMerge : false,
    //====  Pagination  ==========================//
    /**
     * [PAGE] pagination : Pagination 여부
     * 페이지네이션 여부를 지정합니다.
     * pagination 옵션은 infinity scroll을 무시하고 먼저 적용됩니다.
     * 자동으로 하단에 Pagination 모듈을 보여줍니다.
     * 사용자 지정 모듈을 사용하고 싶은 경우 pager slot을 사용해주세요.
     * 전체 페이지 크기를 위해서 
     * Default : false
     */
    pagination : false,
    /**
     * [PAGE] internalPaging : 내부 페이징 여부
     * 그리드 내부에서 페이지 처리를 할지에 대한 옵션입니다.
     * 내부 페이지 처리를 위해서는 전체 데이터를 입력해주세요.
     * 별도의 itemSize를 요구하지 않습니다.
     */
    internalPaging : false,
    /**
     * [PAGE] defaultPageSize : 기본 page size
     * 최초 그리드가 표시될 때의 기본 page size를 설정합니다.
     * 사용자 조작에 의한 변경과는 무관합니다.
     * defaultPageSize를 지정할 때에는 pageList에 해당 값이 있어야 합니다.
     * Default : 10
     */
    defaultPageSize : 10,
    /**
     * [PAGE] pagingList : 기본 page size의 목록
     * 기본 pagination을 사용할 때에 선택 가능한 pagination의 목록입니다.
     * defaultPageSize를 지정할 때에는 pageList에 해당 값이 있어야 합니다.
     * Default : [10,15,30]
     */
    pagingList : [10,15,30],
    /**
     * [PAGE] simplePagination : 간단한 형태의 pagination 사용 여부
     * 간단한 형태의 paginaiton을 지정합니다.
     * Default : false
     */
    simplePagination : false,
    //====  Editable  ==========================//
    /**
     * [EDIT] rowEdit : 행 수정모드
     * 테이블을 행 수정모드로 할 것인지 여부.
     * 상단의 추가 Action bar를 활성화 합니다.
     * Default : false
     */
    rowEdit : false,
    /**
     * [EDIT] cellEdit : 셀 수정모드
     * 테이블을 셀 수정모드로 할 것인지 여부.
     * Default : false
     */
    cellEdit : false,
    /**
     * [EDIT] editable : 수정모드
     * 테이블을 수정가능한지 설정합니다.
     * 기본 동작은 rowEdit 모드이지만,
     * cellMode가 true인 경우 cellEdit모드로 동작합니다.
     * Default : false
     */
    editable : false,
    /**
     * [DATA] defaultValue : 기본 값
     * 새로 데이터를 추가하거나 할 때에 사용되는 행 단위의 기본값 입니다.
     * 그리드 옵션으로 지정할 경우 정적인 데이터만 입력할 수 있습니다.
     * 동적인 데이터나 로직이 필요한 경우 헤더의 defaultValue 옵션을 사용해주세요.
     */
    defaultValue : null,
    /**
     * [EDIT] manualValid : 수동 검사모드
     * 수정시에 validation 체크를 자동으로 수행하지 않습니다.
     * validChanged 또는 별도의 logic을 구성하여 검사해주세요.
     * Default : false
     */
    manualValid : false,
    /**
     * [EDIT] authCreate : 생성 권한
     * 그리드를 수정할 때에 생성 기능을 허용할지 여부.
     * Default : false
     */
    authCreate : true,
    /**
     * [EDIT] authUpdate : 수정 권한
     * 그리드를 수정할 때에 수정 기능을 허용할지 여부.
     * Default : false
     */
    authUpdate : true,
    /**
     * [EDIT] authRemove : 삭제 권한
     * 그리드를 수정할 때에 삭제 기능을 허용할지 여부.
     * Default : false
     */
    authRemove : true,
    /**
     * [EDIT] keepEditable : 수정모드 유지
     * 탭/엔터를 통해 셀을 이동할 때에 수정모드인 경우 수정모드를 유지할지 여부.
     * 옵션이 설정된 경우 수정모드에서 탭/엔터를 눌렀을 때에 변경된 값을 저장하고
     * 다음 셀로 이동시키면서, 해당 셀이 수정 가능한 경우 수정모드로 변경한다.
     * Default : false
     */
    keepEditable : false,
    /**
     * [EDIT] autCreateOnPaste : 붙여넣기시 자동 행 추가
     * 그리드에 값을 붙여넣기 할 때 생성된 행에 추가하는 경우
     * 생성된 행(Temp row)이 부족한 경우 자동으로 행을 생성하여 작성합니다.
     * Default : false
     */
    autoCreateOnPaste : false,
    /**
     * [EDIT] blockDelete : 삭제 가능 여부
     * 해당옵션이 활성화 된 경우 데이터를 삭제 전 가능여부를 체크합니다.
     * 값을 Boolean값 true로 지정한 경우 기본적으로 조회된 데이터를 삭제할 수 없습니다.
     * 다만 사용자가 추가한 데이터의 경우 삭제가 가능하며, 
     * 이 경우는 삭제 권한과 별개로 인식합니다.
     * 해당 속성에는 함수 형태로도 입력이 가능합니다.
     * 매개변수로 행 정보를 입력 받아 수정 가능 여부를 true/false로 반환합니다.
     * 해당 함수는 선택된 행을 대상으로 매 행마다 수행여부를 체크합니다.
     *     ex) blockDelete : function(row) {return row.__dirty === 'C'}
     * Default : false
     */
    blockDelete : false,
    /**
     * [EDIT] dateReturnType : 날짜 반환 타입
     * 날따 형태의 값을 수정하였을 때에 적용될 값 유형
     * date / long / string 형태의 값 중에서 선택 가능합니다.
     * default : 'date'
     */
    dateReturnType : 'date',
    /**
     * [EDIT] blockAutoSelectOnDelete : 단건 삭제 후 자동선택 금지
     * 단건 삭제 이후 다음 행을 자동으로 선택하게 하는 기능을 금지합니다.
     */
    blockAutoSelectOnDelete : false,
    //====  Message  ==========================//
    /**
     * [MESSAGE] msgTotal : 그리드의 총 건수를 표시하기 위한 메시지
     *   - # 위치에는 총 건수가 들어갑니다.
     *   ex) "Total #" -> Total <b>63</b>
     * Default : Total #
     */
    msgTotal : "Total #",
    /**
     * [MESSAGE] msgTotal : 페이지 당 보여줄 건수를 표시하기 위한 메시지
     *   - # 위치에는 페이지당 보여줄 건수가 들어갑니다.
     *   ex) "# per page" -> <b>10</b> per page 
     * Default : # per page
     */
    msgPerPage : "# per page",
    /**
     * [MESSAGE] msgAscending : 오름차순 메시지
     * 정렬의 오름차순 메시지에 대한 정의 입니다.
     * Default : Sort Ascending
     */
    msgAscending  : "Sort Ascending",
    /**
     * [MESSAGE] msgDescending : 내림차순 메시지
     * 정렬의 내림차순 메시지에 대한 정의 입니다.
     * Default : Sort Descending
     */
    msgDescending : "Sort Descending",
    /**
     * [MESSAGE] msgEmptyData : 데이터 없음 경고 메시지
     * 데이터가 없는 경우 보여줄 메시지 입니다.
     * Default : No data to display
     */
    msgEmptyData : "No data to display",
    /**
     * [MESSAGE] msgSelectedCnt : 선택건수 메시지
     * 상단 Action영역에 보여질 메시지 입니다.
     *   - # 위치에는 선택된 row 수가 보여집니다.
     *   ex) "# item(s) selected" -> 10 item(s) selected
     * Default : # item(s) selected
     */
    msgSelectedCnt : "# item(s) selected",
    /**
     * [MESSAGE] msgBtnAdd : '추가'버튼 메시지
     * 기본으로 제공되는 추가 버튼에 대한 메시지 입디다.
     * Default : Add
     */
    msgBtnAdd : "Add",
    /**
     * [MESSAGE] msgBtnDelete : '삭제'버튼 메시지
     * 기본으로 제공되는 삭제 버튼에 대한 메시지 입디다.
     * Default : Delete
     */
    msgBtnDelete : "Delete",
    /**
     * [MESSAGE] msgBtnModify : '추가'버튼 메시지
     * 기본으로 제공되는 추가 버튼에 대한 메시지 입디다.
     * Default : Modify
     */
    msgBtnModify : "Modify",
    /**
     * [MESSAGE] msgBtnSave : '저장'버튼 메시지
     * 기본으로 제공되는 저장 버튼에 대한 메시지 입디다.
     * Default : Modify
     */
    msgBtnSave : "Save",
    /**
     * [MESSAGE] msgBtnCancel : '취소'버튼 메시지
     * 기본으로 제공되는 취소 버튼에 대한 메시지 입디다.
     * Default : Modify
     */
    msgBtnCancel : "Cancel",
    /**
     * [MESSAGE] msgCalendarToday : (달력)'오늘'버튼 메시지
     * 달력 컴포넌트에서 '오늘' 버튼을 위한 메시지 입니다.
     * Default : Today
     */
    msgCalendarToday : "Today",
    /**
     * [MESSAGE] msgCalendarConfirm : (달력)'확인'버튼 메시지
     * 달력 컴포넌트에서 '확인' 버튼을 위한 메시지 입니다.
     * Default : Confirm
     */
    msgCalendarConfirm : "Confirm",
    /**
     * [MESSAGE] msgValidRequired : (검증)필수값 오류 메시지
     * 필수인 항목에 값이 입력되지 않았을 경우 출력될 메시지 입니다.
     *   - $ 위치에는 해당 필드의 이름이 보여집니다.
     *   ex) "$ is required" -> ID is required
     * Default : $ is required.
     */
    msgValidRequired : "$ is required.",
    /**
     * [MESSAGE] msgValidMinValue : (검증)최소값 오류 메시지
     * 값이 최소값 기준에 허용되지 않을 경우 .
     *   - $ 위치에는 해당 필드의 이름이 보여집니다.
     *   - # 위치에는 기준이되는 최소값이 보여집니다.
     *   ex) "$ has to be larger than #." -> Age has to be larget than 10.
     * Default : $ has to be larger than #.
     */
    msgValidMinValue : "$ has to be larger than #.",
    /**
     * [MESSAGE] msgValidMinLength : (검증)최소길이 오류 메시지
     * 값이 최소길이 기준에 허용되지 않을 경우 .
     *   - $ 위치에는 해당 필드의 이름이 보여집니다.
     *   - # 위치에는 기준이되는 최소길이가 보여집니다.
     *   ex) "$ has to be longer than # char." -> Password has to be longer than 10 char.
     * Default : $ has to be longer than # char.
     */
    msgValidMinLength : "$ has to be longer than # char.",
    /**
     * [MESSAGE] msgValidMaxValue : (검증)최대값 오류 메시지
     * 값이 최대값 기준에 허용되지 않을 경우 .
     *   - $ 위치에는 해당 필드의 이름이 보여집니다.
     *   - # 위치에는 기준이되는 최대값이 보여집니다.
     *   ex) "$ has to be smaller than #." -> Age has to be smaller than 150.
     * Default : $ has to be smaller than #.
     */
    msgValidMaxValue : "$ has to be smaller than #.",
    /**
     * [MESSAGE] msgValidMaxLength : (검증)최대길이 오류 메시지
     * 값이 최대길이 기준에 허용되지 않을 경우 .
     *   - $ 위치에는 해당 필드의 이름이 보여집니다.
     *   - # 위치에는 기준이되는 최대길이가 보여집니다.
     *   ex) "$ has to be shorter than # char." -> Password has to be shorter than 10 char.
     * Default : $ has to be shorter than # char.
     */
    msgValidMaxLength : "$ has to be shorter than # char.",
    /**
     * [MESSAGE] msgContextConfirm : (Context)'확인'버튼 메시지
     * 헤더 변경등의 컨텍스트 팝업에서 '확인' 버튼을 위한 메시지 입니다.
     * Default : Confirm
     */
    msgContextConfirm : "Confirm",
    /**
     * [MESSAGE] msgContextFreezeGuide : (Context)틀고정 선 안내메시지
     * 헤더 변경 컨텍스트 팝업에서 틀고정 위치표시 선의 안내 메시지입니다.
     * 마우스를 올려두었을때 툴팁형태로 보여집니다.
     * Default : Freeze grid here
     */
    msgContextFreezeGuide : "Freeze grid here",
    /**
     * [MESSAGE] msgContextFreezeIcon : (Context)틀고정 아이콘 안내메시지
     * 컬럼별 틀고정 아이콘의 안내 메시지입니다.
     * Default : Freeze column
     */
    msgContextFreezeIcon : "Freeze column",
    /**
     * [MESSAGE] msgContextShowIcon : (Context)보이기/숨기기 아이콘 안내메시지
     * 컬럼별 보이기/숨기기 아이콘 안내메시지 입니다.
     * Default : Show/Hide column
     */
    msgContextShowIcon : "Show/Hide column",
    /**
     * [MESSAGE] focusOn : (Context) 가장 마지막 선택한 행 표시
     * 가장 마지막 선택한 행을 표시합니다. 여러 행 선택이 가능할 시 가장 마지막에 선택한 행에만 focus 스타일이 추가됩니다.
     * Default : false
     */
    focusOn : false,
    /**
     * [MESSAGE] activeOn : (Context) 현재 클릭한 행 표시
     * 현재 클릭한 행에 active 스타일이 추가됩니다. 클릭이 완료된 후에는 active 스타일이 제거됩니다.
     * Default : false
     */
    activeOn : false,
}




/**************************************************/
/**** Data Grid : Default Field(Header) info.  ****/
/**************************************************/
const DEFAULT_FIELD = {
    /**
     * [COMMON] value : 해당 필드의 키
     * Object 또는 Field 목록에서 유일한 식별자
     * 테이블 표시시점에 Object에서 데이터를 가져올 때 활용됨
     * $REQUIRED
     */
    value : null,
    /**
     * [COMMON] text : 해당 필드의 이름
     * 테이블의 헤더에 표시된다.
     * 없는 경우 Value값을 이어받음
     */
    text : null,
    /**
     * [DATA] key : 키 필드 여부
     * 데이터 셋 중 key filed를 지정합니다.
     * 지정하지 않는 경우 row_index로 자동 지정됩니다
     */
    key : false,
    /**
     * [DATA] type : 필드의 유형
     * 해당 필드의 값이 갖는 유형을 의미한다.
     * 셀에 표시되거나 데이터를 다룰 때에 유형을 기반으로 동작합니다.
     * domain  : [string, number, date, code...]
     * default : string
     */
    type : 'string',
    /**
     * [DATA] defaultValue : 기본 값
     * 새로 데이터를 추가하거나 할 때에 사용되는 해당 필드의 기본값입니다.
     */
    defaultValue : null,
    /**
     * [STYLE] width : 필드의 너비
     * 값은 px 단위로 입력합니다.
     * 아무런 값을 지정하지 않는 경우 options의 defaultColumnWidth값을 추종합니다.
     */
    width : null,
    /**
     * [STYLE] freeze : 틀고정 여부
     * 해당 컬럼을 틀고정 할지를 결정합니다.
     * 틀고정 flag는 앞에서 부터 연이어 등록된 필드만 지정됩니다.
     * ex) 1st : true, 2nd : true, 3rd : true, 4th : false, 5th : true
     *     => 1~3 필드만 틀고정
     * headers 옵션을통해 설정된 필드의 순서는 항상 보장됩니다.
     * 앞에서 부터 최소 1개 이상의 틀고정이 설정된 경우 grid는 틀고정 모드로 동작합니다.
     * 일반 모드와는 일부 DOM 구조나 동작이 상이할 수 있습니다.
     * default : false
     */
    freeze : false,
    /**
     * [DATA] sort : 정렬 여부
     * 필드를 정렬할지 여부를 결정합니다.
     * 값을 true로 설정할 경우 해당 필드는 정렬이 가능합니다.
     * 필요한 경우 (x,y)=>{} 의 형태로 사용자 정의 정렬 기능을 활성화 할수 있습니다.
     * 사용자 정의 정렬을 위해서는, sort 속성에 비교함수를 입력합니다.
     * (이때도 정렬 여부는 true로 간주합니다.)
     *      ex) sort : (value1, value2, data1, data2) => {return [-1 | 0 |1]}
     * 비교 함수는 4개의 매개변수를 갖습니다. 
     *      value1 : 첫번째 값
     *      value2 : 두번째 값
     *      data1 : 첫번째 객체(data)
     *      data2 : 두번째 객체(data)
     * 그리드의 정렬은 지정된 알고리즘에 따라 두개의 값(객체)를 반복해서 비교하는 방식으로 수행되며
     * 각 비교는(함수의 반환값)은 두 값이 다른 경우 대소에 따라 -1/1, 또는 값이 같은 경우 0을 반환합니다.
     * Javascript의 Array.prototype.sort 함수를 사용합니다.
     * [boolean | function]
     * default : false
     */
    sort : false,
    /**
     * [FILTER] filter : 검색 여부
     * 필드를 검색할지 여부를 결정합니다.
     * filter 외에 다른 옵션을 지정하지 않는경우 기본 제공되는 형태로
     * 검색 기능을 제공합니다.
     * default : false
     */
    filter : false,
    /**
     * [FILTER] checker : 체크 방식/체크 함수
     * 필드 검색시 체크방식/체크 함수를 지정합니다.
     * 체크 방식은 사전 제공되는 몇가지 기능을 활용 가능합니다.
     *     stringLike       : 문자열을 포함하는지 비교합니다. string type 필드의 기본 검색 입니다.
     *     stringMatch      : 문자열이 정확히 일치할 경우만 허용합니다.
     *     stringCaseIgnore : 문자열을 포함하는지 비교합니다. 대소문자 구분을 하지 않습니다.
     *     number           : 숫자가 정확히 일치하는지 비교합니다. number type 필드의 기본 검색입니다.
     *     numberRange      : 숫자의 범위 지정이 가능합니다.
     *     date             : 날짜를 비교합니다. 해당 일자의 00시부터 24시까지의 데이터를 비교합니다.
     *     dateRange        : 기간에 포함되는지 체크합니다.
     *     boolean          : true/false 여부를 확인합니다. 코드와 유사하게 true/false는 배열로 전달됩니다.
     *     code             : 제공된 목록에서 코드가 존재하는지 비교합니다. domain 속성이 필요합니다.
     *     match            : 그 외 대부분의 경우 정확히 값이 일치하는 경우 허용합니다.
     * 체크 함수는 세개의 매개변수를 받습니다.
     * ex) checker : (value, condition, row) => {return [true or false]}
     *     value     : 첫번째 매개변수는 검색할 필드 값 입니다.
     *     condition : 검색하고자 하는 검색어 또는 검색 조건이 들어옵니다.
     *                 상황에 따라 다른 검색조건이 제공됩니다.
     *     row       : 검색 대상의 row 전체 값 입니다.
     * [string | function]
     * default : null
     */
    checker : null,
    /**
     * [DOMAIN] domain : 정의역
     * 데이터가 갖을 수 있는 값의 후보입니다.
     * string 유형의 필드의 경우 custom checker를 위해 활용할 수 있습니다.
     * 기본 검색기능 또는 수정 시 dropdown 컴포넌트를 생성할 때에 활용됩니다.
     * default : null
     */
    domain : null,
    /**
     * [STYLE] customClass : 사용자 정의 클래스
     * 사용자가 정의 한 클래스를 지정합니다.
     * 클래스는 해당 컴포넌트에서 식별 가능하여야 합니다.
     *    => <style scoped/> 태그 불가능
     * grid 컴포넌트 또는 페이지에 ID 등의 식별자를 추가하여 원하는 위치에만
     * 적용되도록 하는것을 추천합니다.
     * [string | array]
     * default : null
     */
    customClass : null,
    /**
     * [STYLE] customStyle : 사용자 정의 스타일
     * 사용자가 정의 한 스타일을 지정합니다.
     * height, width, left 속성은 그리드 cell 위치 지정에 필요한 속성이므로 적용되지 않습니다.
     * 작성은 object 형태로 작성해주세요.
     * ex) {'font-wieght':'bold'}
     * default : null
     */
    customStyle : null,
    /**
     * [STYLE] customValue : 사용자 정의 값
     * 셀에 표시되는 정보를 사용자 지정합니다.
     * customValue를 지정하였을때 value 값은 필드명이 아니더라도
     * 다른 필드와 겹치지 않는 임의의 값으로 지정할 수 있습니다..
     * 정렬 및 필터 기능은 커스터마이징 되어야 합니다.
     * 입력은 함수 형태로 입력받습니다.
     * ex) customValue : function(value, row) {return 'new value'}
     *     value : value를 필드명으로 지정하였을때에 해당하는 값을 전달합니다.
     *     row : 해당 row의 전체 값을 전달합니다.
     * default : null
     */
    customValue : null,
    /**
     * [STYLE] align : 정렬 방식
     * 문자열의 정렬을 지정합니다.
     * 내부적으로 text-align style을 사용합니다.
     * 지정하지 않을 경우 각 필드의 타입별로 내정된 정렬을 따릅니다.
     * ['left'|'right'|'center']
     * default : null
     */
    align : null,
    /**
     * [STYLE] component : 사용자 지정 컴포넌트
     * 셀에 표시될 내용을 사용자 지정 컴포넌트로 표시되게 지정할 수 있습니다.
     * 지정되지 않는경우(null) 기존 그리드 방식대로 셀을 표기합니다.
     * 지정된 컴포넌트는 3개의 Props를 제공받습니다.
     *     row   : 해당 row 데이터 전체
     *     value : 필드의 value 키워드로 찾은 셀의 값
     *     text  : customValue 등의 옵션으로 변환된 화면에 표시되는 값
     * 컴포넌트 지정시에는 위 props중 필요한 값을 선언해주세요.
     * 컴포넌트의 지정은 3가지 방식으로 가능합니다.
     * 1) Component 형태
     * 상단에 Cell의 내용으로 활용될 Component를 import 하고 필드 지정시에 component 속성에 입력합니다.
     * ex) import sub_compo from "./child/subCompo.vue";
     *     ...(중략)
     *     { value:'myVal', component: sub_compo }
     * 2) String 형태
     * 간단한 형태는 String 형태로 지정가능합니다.
     * ex) { value:'myVal', component: "<my-compo>{text}</my-compo>" }
     * 자동으로 컴포넌트를 생성하여 row, value, text props를 전달해줍니다.
     * 3) inline 형태
     * 별도의 .vue 파일 없이 inline 형태로 컴포넌트를 지정 가능합니다.
     * ex) { value:'myVal', component: {
     *         template : `<ur-icon icon='home'/>{decoVal}`,
     *         computed : { decoVal() {return "<"+value + ">";} }
     *     }}
     * default : null
     */
    component : null,
    /**
     * [STYLE] editComponent : 사용자 지정 컴포넌트(수정용)
     * 셀 또는 행이 수정모드로 들어갈 때에 사용할 컴포넌트 입니다.
     * 상세한 사용법은 일반 component와 동일합니다.
     * default : null
     */
    editComponent : null,
    /**
     * [EVENT] click : 클릭 이벤트 콜백
     * 클릭했을때의 이벤트를 제공합니다.
     * 이벤트의 입력은 함수 형태로 입력할 수 있습니다.
     * ex) click : (val, row, field, event) => { do something here... }
     *     val   : 클릭한 셀의 값입니다.
     *     row   : 해당 row 전체 값입니다.
     *     field : 클릭한 field의 정보입니다.
     *     event : 클릭 이벤트 객체입니다.
     */
    click: null,
    /**
     * [EDIT] edit : 수정가능여부
     * 해당 필드를 수정할수 있는지 여부를 지정합니다.
     * 그리드의 rowEdit 옵션이 활성화 되면 자동으로 모든 필드는 edit true 상태가 됩니다.
     * 단, 데이터를 생성할 때에는 값을 입력할 수 있습니다.
     * 생성시의 수정여부는 readonly 옵션을 사용해주세요.
     * 값은 함수 형태로도 입력 가능합니다.
     * 매개변수로는 Value, Row, Field 정보가 입력되며 Boolean값을 반환하면 됩니다.
     *     ex) edit : function(value, row, field) {return false;}
     * default : true
     */
    edit : true,
    /**
     * [EDIT] readonly : 읽기전용 여부(수정가능여부 포함)
     * 해당 필드가 읽기전용 필드인지를 지정합니다.
     * 읽기전용 필드로 지정된 경우 해당 필드는
     * 수정시를 포함하여 생성할 때에도 값을 입력할 수 없습니다.
     * 옵션이 활성화 된 경우 edit 옵션은 무시됩니다.
     * default : false
     */
    readonly : false,
    /**
     * [VALID] rules : 필드 규칙
     * 해당 필드를 수정할 때에 값의 규칙을 지정합니다.
     * rules 속성은 함수의 배열 형태로 작성합니다. 
     * 각각의 함수는 규칙함수로, true 또는 문자열 값을 반환하게 됩니다.
     * 규칙 함수의 반환값이 true가 아닐경우, 해당 규칙은 실패한것으로 간주하며, 
     * 반환된 값을 사용하여 에러 메시지를 출력합니다.
     * ex) [function(v) {return v>10 || '10보다 큰 값이 필요합니다.'},
     *      (v) => !!v || 'Return message here.']
     * 규칙이 하나밖에 없는경우 예외적으로 배열 없이 함수를 직접 입력 가능합니다.
     * ex) {value:'Somthin', rules: (v) => !!v || 'Value is required'}
     */
    rules : null,
    /**
     * [VALID] required : 필수값 여부
     * 해당 필드가 필수인지 여부를 지정합니다.
     * 필수값 필드에 대해서는 "제목 우측에 * 을 표기합니다.'
     */
    required: null,
    /**
     * [VALID] min : 최소값
     * 해당 필드에 적용될 최소값 입니다.
     * 수정중 또는 수정후 저장시에 규칙 검증 용도로 사용됩니다.
     * 최소값은 필드 유형마다 약간씩의 차이를 갖습니다.
     *     String : 문자열의 최소 길이
     *     Number : 숫자가 갖을수 있는 최소값, 
     *              수정시 Stepper 컴포넌트의 min props와 연동됩니다.
     *     Date   : 날짜가 갖을수 있는 최소값,
     *              수정시 Date-picker 컴포넌트의 min-date props와 연동됩니다.
     */
    min: null,
    /**
     * [VALID] min : 최대값
     * 해당 필드에 적용될 최대값 입니다.
     * 수정중 또는 수정후 저장시에 규칙 검증 용도로 사용됩니다.
     * 최대값은 필드 유형마다 약간씩의 차이를 갖습니다.
     *     String : 문자열의 최대 길이
     *     Number : 숫자가 갖을수 있는 최대값, 
     *              수정시 Stepper 컴포넌트의 max props와 연동됩니다.
     *     Date   : 날짜가 갖을수 있는 최대값,
     *              수정시 Date-picker 컴포넌트의 max-date props와 연동됩니다.
     */
    max: null,
    /**
     * [STYLE] resizable : 너비변경 여부
     * 해당 필드의 너비를 변경할 수 있는지 여부입니다.
     * 해당 옵션만으로 너비 변경여부를 결정할 수는 없습니다.
     * 다만, 전역 옵션인 'resizableColumn'이 true 더라도 필드 단위로 Resize 여부를 비활성화 할 수 있습니다.
     * (resizableColumn이 false면, 필드 단위의 옵션이 활성화 되어도 무시됩니다.)
     * Default : true
     */
    resizable : true,
    /**
     * [CONTEXT] context : 컨텍스트 메뉴
     * 셀 영역을 우클릭을 했을때 나타나는 컨텍스트 메뉴를 지정합니다.
     * 전역 컨텍스트 메뉴와 별개로 각 필드별로 지정 가능합니다.
     * 전역 컨텍스트 메뉴와 함께 등록이 된 경우 자동으로 구분선이 그어집니다.
     * 값은 배열, 배열을 반환하는 함수, 또는 문자열 형태로 입력합니다.
     * Context Array(Array function) :
     *     각 배열은 객체 형태의 데이터를 사용하여 정의됩니다.
     *         [{text:'', action:'', icon:''},...]
     *         text   : Context 메뉴에 보일 제목을 입력합니다.
     *         action : 함수형태의 값을 입력합니다.
     *             클릭한 셀의 값과 행 정보를 매개변수로 받습니다.
     *             ex) action : function(val, row) {... do something}
     *         icon   : OPUS 표준 아이콘명을 입력합니다.
     *     만약 구분선을 추가하고 싶은 경우, 아래와 같은 객체를 입력합니다.
     *         {separator:true}
     * Context string :
     *     문자열로 입력한 경우 컨텍스트 메뉴를 선택하였을 때
     *     @grid:context:{keyword} 형태의 이벤트를 받을 수 있습니다.
     */
    context : null,
    /**
     * [CONTEXT] headerContext : 헤더 컨텍스트 메뉴
     * 헤더 영역의 컨텍스트 메뉴를 지정합니다.
     * 사용은 필터 기능과 같이 헤더를 클릭하여 컨텍스트 메뉴를 호출합니다.
     * 전역 컨텍스트 메뉴와 함께 등록이 된 경우 자동으로 구분선이 그어집니다.
     * 값은 배열, 배열을 반환하는 함수, 또는 문자열 형태로 입력합니다.
     * Context Array(Array function) :
     *     각 배열은 객체 형태의 데이터를 사용하여 정의됩니다.
     *         [{text:'', action:'', icon:''},...]
     *         text   : Context 메뉴에 보일 제목을 입력합니다.
     *         action : 함수형태의 값을 입력합니다.
     *             클릭한 필드의 정보를 매개변수로 받습니다.
     *             ex) action : function(field) {... do something}
     *         icon   : OPUS 표준 아이콘명을 입력합니다.
     *     만약 구분선을 추가하고 싶은 경우, 아래와 같은 객체를 입력합니다.
     *         {separator:true}
     * Context string :
     *     문자열로 입력한 경우 컨텍스트 메뉴를 선택하였을 때
     *     @grid:context:{keyword} 형태의 이벤트를 받을 수 있습니다.
     */
    headerContext : null,
    /**
     * [STYLE] hide : 은신
     * 옵션을 활성화 한 경우 해당 필드를 숨깁니다.
     * 외부에서도 사용할 수는 있지만, 대체로 내부 기능 목적으로 활용됩니다.
     */
    hide : false,
    /**
     * [GROUP] summary : 요약 수식
     * groupSummary 옵션을 활성화 하였을 때 각 셀에서 보여줄 내용을 반환합니다.
     * 옵션의 값은 함수 형태로 입력 가능합니다.
     * 입력된 함수의 매개변수는 각 그룹별 데이터 배열이 전달됩니다.
     *     ex) summary : (data, node) => {return 'something'}
     *         data : 각 그룹별로 속해있는 데이터 배열입니다.
     *         node : 해당 그룹의 노드 정보입니다.
     */
    summary : null,
    /**
     * [FORMAT] dateFormat : 필드 날짜 포멧
     * 필드에만 적용되는 날짜의 포멧입니다.
     * 값을 넣지 않는경우 그리드 전역 설정이 적용됩니다.
     */
    dateFormat : null,
    /**
     * [FORMAT] numberFormat : 필드 숫자 포멧
     * 필드에만 적용되는 숫자의 포멧입니다.
     * 값을 넣지 않는경우 그리드 전역 설정이 적용됩니다.
     */
    numberFormat : null,
    /**
     * [EDIT] beginCellEdit : 셀 수정 전 후크 메소드
     * 셀 수정시 수정 직전에 호출되는 메소드
     * 매개변수로는 Value, Row, Field 정보가 입력됩니다.
     *     ex) beginCellEdit : function(value, row, field) {...CODE...}
     */
    beginCellEdit : null,
    /**
     * [EDIT] endCellEdit : 셀 수정 후 후크 메소드
     * 셀 수정시 수정 후에 호출되는 메소드
     * 매개변수로는 Value, Row, Field 정보가 입력됩니다.
     *     ex) endCellEdit : function(value, row, field) {...CODE...}
     */
    endCellEdit : null,
    /**
     * [COPY] pasteConverter : 붙여넣기 변환기
     * 값을 그리드에 붙여넣을때에 데이터를 변환할 수 있는 함수입니다.
     * 속성의 값은 함수형태로 입력합니다.
     *     ex) pasteConverter: (val, row, fil) => "#"+val,
     *         val : 클립보드(Clipboard)에 저장되어있던 값 입니다.
     *         row : 데이터를 붙여넣을 대상 row입니다. 
     *               값은 headers 배열에 들어가있는 순서대로 들어가게 됩니다.
     *               선행 컬럼에서 함수를 호출했을때 후행 컬럼의 데이터는
     *               아직 들어가기 전 일수 있습니다.
     *         fil : 넣고자 하는 필드의 정보입니다.
     */
    pasteConverter : null,
    /**
     * [COPY] saveConverter : 저장 변환기
     * 값을 수정하고 저장 할때에 데이터를 변환할 수 있는 함수입니다.
     * 속성의 값은 함수형태로 입력합니다.
     *     ex) saveConverter: (val, row, fil) => "#"+val,
     *         val : 클립보드(Clipboard)에 저장되어있던 값 입니다.
     *         row : 데이터를 붙여넣을 대상 row입니다. 
     *               값은 headers 배열에 들어가있는 순서대로 들어가게 됩니다.
     *               선행 컬럼에서 함수를 호출했을때 후행 컬럼의 데이터는
     *               아직 들어가기 전 일수 있습니다.
     *         fil : 넣고자 하는 필드의 정보입니다.
     */
    saveConverter : null,
    /**
     * [COPY] timezone : 필드의 Timezone
     * 필드별로 timezone을 별도 지정하려 할 때에 사용됩니다.
     * 기본값은 null이며 그리드 전역 설정을 적용받습니다.
     */
    timezone : null,
}

export default {
    OPTS : DEFAULT_OPTIONS,
    FIELD : DEFAULT_FIELD
}
